export const COMPACT = 1;
export const REGULAR = 2;
export const FULLLSCREEN = 3;
export const TABLET = 4;
export const TABLETPORTRAIT = 5;
